import axios from 'axios';
import { logoutUser } from './dataService';

const API_URL = 'https://apienglish.nguyenluan.vn/api/word-scramble';

const handleApiError = (error, defaultMessage) => {
    console.error(`Word Scramble API Error:`, error.response ? error.response.data : error.message);
    if (error.response && error.response.status === 401) {
        logoutUser();
        throw new Error('Token không hợp lệ hoặc đã hết hạn. Đang đăng xuất...');
    }
    const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || defaultMessage;
    throw new Error(errorMessage);
};

const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        logoutUser();
        throw new Error('Yêu cầu xác thực. Vui lòng đăng nhập lại.');
    }
    return { headers: { Authorization: `Bearer ${token}` } };
};

const startGame = async (topic, level, wordCount = 1) => {
    try {
        const config = getAuthConfig();
        const response = await axios.post(`${API_URL}/start`, { topic, level, wordCount }, config);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể bắt đầu trò chơi mới.');
    }
};

const makeGuess = async (gameId, guess) => {
    try {
        const config = getAuthConfig();
        const response = await axios.post(`${API_URL}/${gameId}/guess`, { guess }, config);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Gửi lượt đoán không thành công.');
    }
};

const getUserGames = async (status = null, limit = 10, offset = 0) => {
    try {
        const config = getAuthConfig();
        const params = { limit, offset };
        if (status) params.status = status;

        const response = await axios.get(`${API_URL}/games`, { ...config, params });
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể tải danh sách trò chơi.');
    }
};

const wordScrambleService = {
    startGame,
    makeGuess,
    getUserGames,
};

export default wordScrambleService;
